<template>
    <div class="form-group workflow-select">
        <label class="form-label" :for="selectId">Fluxo de trabalho</label>
        <select :id="selectId"
                class="form-control"
                :value="value || ''"
                :disabled="selectDesabilitado"
                @change="$emit('input', Number($event.target.value) || null)">
            <option value="" disabled>{{ placeholder }}</option>
            <option v-for="workflow in workflows"
                    :key="workflow.idProcessoWorkflow"
                    :value="workflow.idProcessoWorkflow">
                {{ workflow.nmProcessoWorkflow || `Fluxo de trabalho ${workflow.idProcessoWorkflow}` }}
            </option>
        </select>
        <small class="text-muted">{{ ajuda }}</small>
    </div>
</template>

<script>
    import axios from 'axios'
    import { urlApi, avisoToast } from '@/config/global'

    export default {
        name: 'SelectWorkflowProcesso',
        props: {
            value: {
                type: [Number, String],
                default: null
            },
            idLegislacao: {
                type: [Number, String],
                default: null
            },
            idTipoProcesso: {
                type: [Number, String],
                default: null
            },
            preferredId: {
                type: [Number, String],
                default: null
            },
            selectId: {
                type: String,
                default: 'workflowProcesso'
            }
        },
        data() {
            return {
                workflows: [],
                carregando: false,
                requisicaoAtual: 0
            }
        },
        computed: {
            configuracaoCompleta() {
                return Number(this.idLegislacao) > 0 && Number(this.idTipoProcesso) > 0
            },
            selectDesabilitado() {
                return !this.configuracaoCompleta || this.carregando || this.workflows.length === 0
            },
            placeholder() {
                if (!this.configuracaoCompleta) return 'Selecione primeiro a legislação e o tipo'
                if (this.carregando) return 'Carregando fluxos de trabalho...'
                if (!this.workflows.length) return 'Nenhum fluxo de trabalho disponível'
                return 'Selecione um fluxo de trabalho'
            },
            ajuda() {
                if (!this.configuracaoCompleta)
                    return 'O campo será liberado após a escolha da legislação e do tipo de processo.'
                if (!this.carregando && !this.workflows.length)
                    return 'O cliente não possui fluxo de trabalho ativo para esta configuração.'
                return 'O processo seguirá o fluxo de trabalho selecionado.'
            }
        },
        watch: {
            idLegislacao() {
                this.recarregar()
            },
            idTipoProcesso() {
                this.recarregar()
            }
        },
        mounted() {
            this.recarregar()
        },
        methods: {
            emitirEstado() {
                this.$emit('state', {
                    loading: this.carregando,
                    hasWorkflows: this.workflows.length > 0,
                    configComplete: this.configuracaoCompleta
                })
            },
            async recarregar() {
                const requisicao = ++this.requisicaoAtual
                this.workflows = []
                this.$emit('input', null)

                if (!this.configuracaoCompleta) {
                    this.carregando = false
                    this.emitirEstado()
                    return
                }

                this.carregando = true
                this.emitirEstado()
                try {
                    const resposta = await axios.get(`${urlApi}/ProcessoWorkflow/GetWorkflow`, {
                        showLoading: false,
                        params: {
                            idLegislacao: Number(this.idLegislacao),
                            idTipoProcesso: Number(this.idTipoProcesso)
                        }
                    })
                    if (requisicao !== this.requisicaoAtual) return

                    const rows = resposta.data?.success ? (resposta.data?.data?.rows || []) : []
                    this.workflows = rows
                        .map(row => row?.processoWorkflow || row)
                        .filter(workflow => workflow?.flAtivo === true)

                    const valorAtual = Number(this.preferredId || this.value)
                    const selecionado = this.workflows.find(
                        workflow => Number(workflow.idProcessoWorkflow) === valorAtual
                    ) || this.workflows[0]
                    this.$emit('input', selecionado?.idProcessoWorkflow || null)
                } catch (erro) {
                    if (requisicao !== this.requisicaoAtual) return
                    this.workflows = []
                    this.$emit('input', null)
                    avisoToast('Não foi possível carregar os fluxos de trabalho disponíveis.', 'warning')
                } finally {
                    if (requisicao === this.requisicaoAtual) {
                        this.carregando = false
                        this.emitirEstado()
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .workflow-select {
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-top: 18px;
    }

    .form-label {
        margin: 0;
        color: #0f172a;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: .3px;
        text-transform: uppercase;
    }

    .form-control {
        min-height: 48px;
        padding: 12px 46px 12px 16px;
        border: 2px solid rgba(148, 163, 184, .25);
        border-radius: 12px;
        background-color: #fff;
    }

    .form-control:disabled {
        cursor: not-allowed;
        opacity: .7;
    }

    [data-bs-theme="dark"] .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .form-control {
        border-color: rgba(148, 163, 184, .2);
        background-color: rgba(15, 23, 42, .8);
        color: #e2e8f0;
    }
</style>
